import { LayerType } from "../../types";
import { UKPropertyInformationPrintable } from "./RecentApplicationsSummary/RecentApplicationsLayerSummaryPrintable";
import { RecentApplicationsLayerSummaryAccordionContent } from "./RecentApplicationsSummary";
import { PlanningApplicationSelectionSidebar } from "./SelectionSidebar";
import { PlanningApplicationRightClickMenu } from "./PlanningApplicationRightClickMenu";
import { planningApplicationsClickResolver } from "./planningClickResolver";
import { PlanningApplicationsControlPage } from "./PlanningApplicationsControlPage";
import { PlanningApplicationPrintable } from "./PlanningApplicationPrintable";
import { PlanningApplicationsProvider } from "./PlanningApplicationsProvider";
import { PlanningApplicationsMapLayer } from "./PlanningApplicationsMapLayer";
import { PLANNING_APPS_LAYER_TYPE_ID, PLANNING_APPS_RECENT_SUMMARY_LAYER_TYPE_ID } from "./constants";

export const PlanningApplicationsRecentSummaryLayerType: LayerType = {
  id: PLANNING_APPS_RECENT_SUMMARY_LAYER_TYPE_ID,
  LayerSummary: RecentApplicationsLayerSummaryAccordionContent,
  Printable: UKPropertyInformationPrintable,
};

export const PlanningApplicationsLayerType: LayerType = {
  id: PLANNING_APPS_LAYER_TYPE_ID,
  MapLayer: PlanningApplicationsMapLayer,
  ControlPage: PlanningApplicationsControlPage,
  Provider: PlanningApplicationsProvider,
  clickResolver: planningApplicationsClickResolver,
  RightClickMenu: PlanningApplicationRightClickMenu,

  SelectionSidebar: PlanningApplicationSelectionSidebar,
  Printable: PlanningApplicationPrintable,
};
